module.exports = __webpack_public_path__ + "assets/splash-screen-2.fd8601ee.svg";